import { Box, Tabs, TabList, TabPanels, TabPanel, Tab } from '@chakra-ui/react'
import { HistoryChart } from '../components/history/HistoryChart'
import { EventLog } from '../components/history/EventLog'

export const History = () => {
  return (
    <Box p={4}>
      <Tabs variant="enclosed" colorScheme="blue">
        <TabList>
          <Tab _selected={{ bg: 'white', borderBottom: 'none' }}>History</Tab>
          <Tab _selected={{ bg: 'white', borderBottom: 'none' }}>Events</Tab>
        </TabList>
        <TabPanels bg="white" borderX="1px" borderBottom="1px" borderColor="gray.200">
          <TabPanel>
            <HistoryChart />
          </TabPanel>
          <TabPanel>
            <EventLog />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
} 